import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from '../Utils';


// Contact
export function getViewManageContacts(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-contacts`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageNonSendableContacts(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-non-sendable-contacts`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageSuppressedContacts(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-suppressed-contacts`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageContactOrders(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-contact-orders`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getViewContactProfileShforms(successCallback, errorCallback, contactId) {
  getAuth({
    "path": `view/contact-profile-shforms/${contactId}`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getViewContactAssociationsShforms(successCallback, errorCallback, contactId) {
  getAuth({
    "path": `view/contact-associations-shforms/${contactId}`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathContacts(contactId=null) {
  if (contactId) {
      return `contacts/${contactId}`;
  } else {
      return `contacts`;
  }
}

export function createContacts(successCallback, errorCallback, data) {
  postAuth({
    "path": pathContacts(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchContacts(successCallback, errorCallback, data, contactId) {
  patchAuth({
    "path": pathContacts(contactId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteContacts(successCallback, errorCallback, contactId, qs={}) {
  deleteAuth({
    "path": urlUtils.appendQueryString(pathContacts(contactId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postSuppressContacts(successCallback, errorCallback, contactId) {
  postAuth({
    "path": `contacts/${contactId}/suppress`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
  });
}

export function postUnsuppressContacts(successCallback, errorCallback, contactId) {
  postAuth({
    "path": `contacts/${contactId}/unsuppress`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
  });
}

export function postResendOptinConfirmationEmail(successCallback, errorCallback, data, contactId) {
  postAuth({
    "path": `contacts/${contactId}/resend-optin-confirmation-email`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function urlUploadSuppressedContacts() {
  return `/${constants.API_VERSION}/contacts/upload-suppressed`;
}



// Contact List
export function getViewManageContactLists(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-contact-lists`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathContactLists(listId=null) {
  if (listId) {
      return `contact-lists/${listId}`;
  } else {
      return `contact-lists`;
  }
}

export function createContactLists(successCallback, errorCallback, data) {
  postAuth({
    "path": pathContactLists(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchContactLists(successCallback, errorCallback, data, listId) {
  patchAuth({
    "path": pathContactLists(listId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteContactLists(successCallback, errorCallback, listId) {
  deleteAuth({
    "path": pathContactLists(listId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function urlContactListContacts(listId) {
  return `/${constants.API_VERSION}/contact-lists/${listId}/upload-contacts`;
}


// Contact Tag
export function getViewManageContactTags(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-contact-tags`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathContactTags(tagId=null) {
  if (tagId) {
      return `contact-tags/${tagId}`;
  } else {
      return `contact-tags`;
  }
}

export function createContactTags(successCallback, errorCallback, data) {
  postAuth({
    "path": pathContactTags(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchContactTags(successCallback, errorCallback, data, tagId) {
  patchAuth({
    "path": pathContactTags(tagId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteContactTags(successCallback, errorCallback, tagId) {
  deleteAuth({
    "path": pathContactTags(tagId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function urlContactTagContacts(tagId) {
  return `/${constants.API_VERSION}/contact-tags/${tagId}/upload-contacts`;
}




// Contact Segment
export function getViewManageContactSegments(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-contact-segments`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathViewContactSegmentShforms(segmentId=null) {
  if (segmentId) {
      return `view/contact-segment-shforms/${segmentId}`;
  } else {
      return `view/contact-segment-shforms`;
  }
}

export function getViewContactSegmentShforms(successCallback, errorCallback, segmentId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewContactSegmentShforms(segmentId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathContactSegments(segmentId=null) {
  if (segmentId) {
      return `contact-segments/${segmentId}`;
  } else {
      return `contact-segments`;
  }
}


export function createContactSegments(successCallback, errorCallback, data) {
  postAuth({
    "path": pathContactSegments(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchContactSegments(successCallback, errorCallback, data, segmentId) {
  patchAuth({
    "path": pathContactSegments(segmentId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteContactSegments(successCallback, errorCallback, segmentId) {
  deleteAuth({
    "path": pathContactSegments(segmentId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Segment Templates
export function getViewManageSegmentTemplates(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-segment-templates`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}



// Contact Activities
export function getViewManageContactActivities(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-contact-activities`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathContactActivities(activityId=null) {
  if (activityId) {
      return `contact-activities/${activityId}`;
  } else {
      return `contact-activities`;
  }
}

export function createContactActivities(successCallback, errorCallback, data) {
  postAuth({
    "path": pathContactActivities(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteContactActivities(successCallback, errorCallback, activityId) {
  deleteAuth({
    "path": pathContactActivities(activityId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Contact Activity Types
export function getViewManageContactActivityTypes(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-contact-activity-types`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathContactActivityTypes(activityTypeId=null) {
  if (activityTypeId) {
      return `contact-activity-types/${activityTypeId}`;
  } else {
      return `contact-activity-types`;
  }
}

export function createContactActivityTypes(successCallback, errorCallback, data) {
  postAuth({
    "path": pathContactActivityTypes(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchContactActivityTypes(successCallback, errorCallback, data, activityTypeId) {
  patchAuth({
    "path": pathContactActivityTypes(activityTypeId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteContactActivityTypes(successCallback, errorCallback, activityTypeId) {
  deleteAuth({
    "path": pathContactActivityTypes(activityTypeId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Contact Properties
export function getViewManagePredefinedContactProperties(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-predefined-contact-properties`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageCustomContactProperties(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-custom-contact-properties`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathContactProptypes(proptypeId=null) {
  if (proptypeId) {
      return `contact-property-types/${proptypeId}`;
  } else {
      return `contact-property-types`;
  }
}

export function createContactProptypes(successCallback, errorCallback, data) {
  postAuth({
    "path": pathContactProptypes(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchContactProptypes(successCallback, errorCallback, data, proptypeId) {
  patchAuth({
    "path": pathContactProptypes(proptypeId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteContactProptypes(successCallback, errorCallback, proptypeId) {
  deleteAuth({
    "path": pathContactProptypes(proptypeId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}



// Bulk Action
export function getViewManageContactsBulkActions(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-contacts-bulk-actions`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageContactsBulkActionLogs(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-contacts-bulk-action-logs`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathViewContactsBulkActionShforms(bulkActionId=null) {
  if (bulkActionId) {
      return `view/contacts-bulk-action-shforms/${bulkActionId}`;
  } else {
      return `view/contacts-bulk-action-shforms`;
  }
}

export function getViewContactsBulkActionShforms(successCallback, errorCallback, bulkActionId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewContactsBulkActionShforms(bulkActionId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathContactsBulkActions(bulkActionId=null) {
  if (bulkActionId) {
      return `contacts-bulk-actions/${bulkActionId}`;
  } else {
      return `contacts-bulk-actions`;
  }
}

export function createContactsBulkActions(successCallback, errorCallback, data) {
  postAuth({
    "path": pathContactsBulkActions(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchContactsBulkActions(successCallback, errorCallback, data, bulkActionId) {
  patchAuth({
    "path": pathContactsBulkActions(bulkActionId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteContactsBulkActions(successCallback, errorCallback, bulkActionId) {
  deleteAuth({
    "path": pathContactsBulkActions(bulkActionId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postExecuteContactsBulkActions(successCallback, errorCallback, bulkActionId) {
  postAuth({
    "path": `contacts-bulk-actions/${bulkActionId}/execute`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function urlExecuteContactsBulkActions(bulkActionId) {
  return `/${constants.API_VERSION}/contacts-bulk-actions/${bulkActionId}/execute`;
}
